export default __webpack_public_path__ + "static/media/dashboard_gold.81336789.svg";